(function (window, $j) {
    $j("#lnkSkip").click(function () {
        var $target = $j(this.hash);
        $target = $target.length && $target
            || $j('[name=' + this.hash.slice(1) + ']');
        if ($target.length) {
            var targetOffset = $target.offset().top;
            $j('html,body')
                .animate({ scrollTop: targetOffset }, 1000);
            if (document.getElementById("bookNowButton") !== null) {
                angular.element("#findAndBookBtn #bookNowButton").focus();
            }
            else {
                document.getElementById("findAndBookBtn").focus();
            }
            return false;
        }
    });
})(window, $j);